import { Card } from "@/components/Card/card";
import { HStack, VStack } from "@/components/Layout";
import { ViewportLoader } from "@/components/Loading";
import { createFileRoute } from "@tanstack/react-router";
import { CustomerCard } from "./-components/CustomerCard";
import { DeliveryCard } from "./-components/DeliveryCard";
import { HandoverNoteCard } from "./-components/HandoverNoteCard";
import { OrderDetailsHeader } from "./-components/Header/OrderDetailsHeader";
import { OrderDetailsCard } from "./-components/OrderDetailsCard";
import { OrderDetailsPaymentCard } from "./-components/OrderDetailsPaymentCard";
import { ShippingCard } from "./-components/ShippingCard";
import { StatusTimeline } from "./-components/StatusTimeline";
import { useSalesOrderDetail } from "./-query";

export const Route = createFileRoute(
  "/_staff/marketplace/sales-orders/$orderId/",
)({
  component: SalesOrderDetail,
});

function SalesOrderDetail() {
  const { orderId } = Route.useParams();
  const { data: order, isLoading } = useSalesOrderDetail(orderId);

  if (isLoading) return <ViewportLoader />;
  if (!order) return null;

  return (
    <VStack className="gap-0">
      <OrderDetailsHeader order={order} />
      <div className="p-12">
        <HStack className="gap-8">
          <VStack className="flex-1 gap-4">
            <CustomerCard orderer={order.orderer} customer={order.customer} />
            <ShippingCard address={order.shippingAddress} />
            <OrderDetailsCard lines={order.lines} />
            <OrderDetailsPaymentCard summaryPrices={order.summaryPrices} />
            <DeliveryCard deliveryDate={order.deliveryDate} />
            <HandoverNoteCard memo={order.handoverMemo} />
          </VStack>
          <Card className="h-fit w-80 p-4">
            <StatusTimeline
              activities={order.activities}
              orderId={orderId}
              isAcceptable={order.isAcceptable}
            />
          </Card>
        </HStack>
      </div>
    </VStack>
  );
}
